import { reduxForm } from 'redux-form'

const withForm = reduxForm 

export default withForm 



// WEBPACK FOOTER //
// ./src/with/Form.js